import { present } from "../../../utils/presenter";
import { Repository } from "../../adapters/repository";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ planzone }) =>
    present(
      repository
        .retrieveDocumentTemplatesFolder(planzone)
        .then((folder) => ({ folder, planzone }))
        .catch(() => Promise.reject({ planzone })),
    );
}

export type { Interactor };

export { createInteractor };
